import { Component, Injector, ChangeDetectionStrategy } from '@angular/core'
import { FormArray, FormGroup, Validators } from '@angular/forms'
import { MatDialog } from '@angular/material/dialog'
import type { PixKeyTypeObject, TemplateMessageObject } from '@trendbuild/trend-cloud-api'
import { AbstractComponent, Channel, ChannelService, ChannelTypeEnum, Company, ConfirmationComponent, MetadataMessage, Traduct, WEBHOOK_INTEGRATIONS_PIX_KEY_TYPES, Webhook, WebhookIntegrationItemType, WebhookIntegrationItemTypeTranslate, WebhookIntegrations, WebhookIntegrationsPix, WebhookIntegrationsService } from 'lib-trend-core'
import { v4 as uuidv4 } from 'uuid'
import { environment } from '../../../../../environments/environment'
import { WebhookIntegrationsRequestsViewComponent } from '../../webhook-integrations/webhook-integrations-requests-view/webhook-integrations-requests-view.component';


@Component({
    selector: 'santri-integrations-form-component',
    templateUrl: './santri-integrations-form.v2.component.html',
    // templateUrl: './santri-integrations-form.component.html',
    styleUrls: ['./santri-integrations-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SantriIntegrationsFormComponent extends AbstractComponent {
  webhookIntegrations?: WebhookIntegrations
  selectedChannel: Channel
  templateMessage: MetadataMessage;

  isActive: boolean = false;
  url: string
  webhookRequests: object
  webhookSelectedId: string
  showPreviewTemplate: boolean
  previewHeader: any
  translator!: Traduct

  requestsSelected: Array<object> = new Array<object>()
  channels: Array<Channel> = new Array<Channel>()

  selectedTemplate: TemplateMessageObject

  webhooks: Array<Webhook> = new Array<Webhook>()

  actionsType: string[];

  breadcrumb = [
    { href: '/integrations', label: 'integrations.breadcrumb.integrations' },
    { href: '/integrations/santri/list', label: 'integrations.breadcrumb.santriWebhooks' },
    { label: '' },
  ]


  constructor(
    injector: Injector,
    public channelService: ChannelService,
    public webhookIntegrationsService: WebhookIntegrationsService,
    public dialog: MatDialog,
  ) {
    super(injector)
    this.createForm();
  }

  ngOnInit() {
    this.webhookIntegrations = <WebhookIntegrations>{}
    const idWebhook = this.getParam('id')
    this.isNew = !idWebhook ? true : false;

    if (!this.isNew) {
      this.breadcrumb[2].label = 'Editar Webhook Santri';
    } else {
      this.breadcrumb[2].label = 'Adicionar Webhook Santri';
    }

    this.isActive = this.webhookIntegrations.actived;
    this.channelService.getList().subscribe({
      next: (channels) => {
        this.channels = channels;
        if (this.isNew) {
          this.webhookIntegrations.uuid = uuidv4();
          this.webhookIntegrations.url = this.generateWebhookIntegrationsURLbyCode(this.webhookIntegrations.uuid);
          this.formGroup.get('url').setValue(this.webhookIntegrations.url);
          this.formGroup.get('company').setValue(this.getIDCurrentCompany());
          this.formGroup.get('uuid').setValue(this.webhookIntegrations.uuid);
          this.addComponent(WebhookIntegrationItemType.WHATSAPP_PHONE);
          this.addComponent(WebhookIntegrationItemType.CONTACT_NAME);
        } else {
          this.webhookIntegrationsService.getById(idWebhook).subscribe({
            next: (webhookIntegrations) => {
              this.webhookIntegrations = webhookIntegrations;
              this.populateForm();
              this.getWebhookRequests();
              this.createActionTypeList();
            },
            complete: () => {
            }
          })
        }
      },
      complete: () => {
      }
    })
  }

  ngAfterViewInit(): void {
  }

  override ngOnDestroy(): void {
  }

  selectChannel(idChannel: string): void {
    this.selectedChannel = this.channels.find((c) => c._id === idChannel)

    this.createActionTypeList();
    if (this.selectedChannel.type === ChannelTypeEnum.CLOUD_API) {
      this.items.controls = this.items.controls.filter((item) => {
        return item.get('type').value !== WebhookIntegrationItemType.ADD_TAG &&
          item.get('type').value !== WebhookIntegrationItemType.REMOVE_TAG
      });
    }
  }

  toggleWebhookStatus() {
    this.webhookIntegrations.actived = !this.webhookIntegrations.actived;
    if (this.isActive && !this.formGroup.valid) {
      this.validateAllFormFields(this.formGroup)
      this.isActive = false;
      return
    }
    if (this.isActive) {
      this.save();
    } else {
      this.ableDisableFields();
    }
  }

  changeChannelDialog(idChannel: string) {
    const dialogRef = this.dialog.open(ConfirmationComponent, {
      data: this.t('integrations.santriForm.changeChannelConfirm'),
      width: '500px',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (Boolean(result) === true) {
        this.selectChannel(idChannel)
        this.alertService.success(this.t('integrations.santriForm.changeChannelSuccess'));
      }
    });
  }

  async copyUrl() {
    try {
      await navigator.clipboard.writeText(this.webhookIntegrations.url)
      this.alertService.info(this.t('integrations.santriForm.urlCopiedInfo'))
    } catch (error) {
      console.error(error.message)
    }
  }

  save() {
    this.loading = true;
    if (!this.formGroup.valid) {
      this.validateAllFormFields(this.formGroup)
      return
    }
    const actions = [];
    this.items.controls.forEach((item) => {
      let action = null;
      if (item.get('type').value === WebhookIntegrationItemType.WHATSAPP_PHONE) {
        action = {
          type: "phone",
          value: item.get('value').value
        }
      } else if (item.get('type').value === WebhookIntegrationItemType.CONTACT_NAME) {
        action = {
          type: "name",
          value: item.get('value').value
        }
      } else if (item.get('type').value === WebhookIntegrationItemType.ADD_TAG) {
        action = {
          type: "addTag",
          value: item.get('value').value
        }
      } else if (item.get('type').value === WebhookIntegrationItemType.REMOVE_TAG) {
        action = {
          type: "removeTag",
          value: item.get('value').value
        }
      } else if (item.get('type').value === WebhookIntegrationItemType.ADD_CONTACT_GROUP) {
        action = {
          type: "addContactGroup",
          value: item.get('value').value
        }
      } else if (item.get('type').value === WebhookIntegrationItemType.REMOVE_CONTACT_GROUP) {
        action = {
          type: "removeContactGroup",
          value: item.get('value').value
        }
      } else if (item.get('type').value === WebhookIntegrationItemType.START_ATTENDANCE) {
        action = {
          type: "attendance",
          value: {
            department: item.get('value').value,
            user: item.get('attendent').value
          }
        }
      }
      actions.push(action);
    });
    const webhookIntegration = <WebhookIntegrations>{
      _id: this.webhookIntegrations._id,
      uuid: this.webhookIntegrations.uuid,
      name: this.formGroup.get('name').value,
      url: this.formGroup.get('url').value,
      actived: this.isActive,
      company: <Company>{ _id: super.getIDCurrentCompany() },
      channel: <Channel>{ _id: this.selectedChannel?._id },
      actions: actions,
      type: 'SANTRI',
      pix: this.buildPix(),
    }

    if (this.webhookSelectedId) {
      webhookIntegration.webhook = <Webhook>{ _id: this.webhookSelectedId };
    }

    if (!this.isNew) {
      this.webhookIntegrationsService
        .update(this.webhookIntegrations._id, webhookIntegration)
        .subscribe({
          next: () => {
            this.alertService.success();
            this.goBack();
          },
          error: (err) => {
            this.alertService.error(err.error.message);
            this.loading = false;
          },
          complete: () => this.loading = false
        })
    } else {
      this.webhookIntegrationsService.create(webhookIntegration).subscribe({
        next: () => {
          this.alertService.success();
          this.goBack();
        },
        error: (err) => {
          this.alertService.error(err.error.message);
          this.loading = false;
        },
        complete: () => this.loading = false
      })
    }
  }

  /** Only for Cloud API channels, and only once the three fields are filled — Meta requires all three. */
  get showPixSection(): boolean {
    return this.selectedChannel?.type === ChannelTypeEnum.CLOUD_API;
  }

  readonly pixKeyTypes: ReadonlyArray<PixKeyTypeObject> = WEBHOOK_INTEGRATIONS_PIX_KEY_TYPES;

  /**
   * Sent as `null` while incomplete rather than as a half-filled object: the send path treats
   * "configured" as all-or-nothing, and a partial payee would only fail later, at Meta.
   *
   * `null` rather than `undefined` because the update is a JSON body — an undefined field is
   * dropped before it leaves the browser, so emptying the fields would silently keep whatever was
   * saved before instead of clearing it.
   */
  private buildPix(): WebhookIntegrationsPix {
    const merchantName: string = (this.formGroup.get('pixMerchantName').value ?? '').trim();
    const key: string = (this.formGroup.get('pixKey').value ?? '').trim();
    const keyType: PixKeyTypeObject = this.formGroup.get('pixKeyType').value;

    return !!merchantName && !!key && !!keyType ? { merchantName, key, keyType } : null;
  }

  private createForm(): void {
    this.formGroup = this.formBuilder.group({
      _id: [null],
      name: [null, Validators.required],
      url: [null, Validators.required],
      channel: [null, Validators.required],
      company: [null, Validators.required],
      actived: [false, Validators.required],
      webhook: [null, []],
      uuid: [null, Validators.required],
      requestType: ['SANTRI', Validators.required],
      tags: [null],
      // DEV-1992 — payee of a PIX payment template. Optional: an integration that never sends one
      // leaves it empty, so no existing webhook becomes invalid.
      pixMerchantName: [null],
      pixKeyType: ['CNPJ'],
      pixKey: [null],
      items: this.formBuilder.array([])
    });
  }

  populateForm() {
    this.formGroup.get('_id').setValue(this.webhookIntegrations._id);
    this.formGroup.get('name').setValue(this.webhookIntegrations.name);
    this.formGroup.get('url').setValue(this.webhookIntegrations.url);
    this.formGroup.get('uuid').setValue(this.webhookIntegrations.uuid);
    this.formGroup.get('actived').setValue(this.webhookIntegrations.actived);
    
    const channelId = typeof this.webhookIntegrations.channel === 'object' 
      ? (this.webhookIntegrations.channel as any)?._id 
      : this.webhookIntegrations.channel;
    this.formGroup.get('channel').setValue(channelId);
    this.selectedChannel = this.channels.find((c) => c._id === channelId);
    this.formGroup.get('webhook').setValue(this.webhookIntegrations.webhook);
    this.formGroup.get('company').setValue(this.webhookIntegrations.company);
    this.webhookSelectedId = this.webhookIntegrations.webhook as unknown as string;
    this.isActive = this.webhookIntegrations.actived;

    this.formGroup.get('pixMerchantName').setValue(this.webhookIntegrations.pix?.merchantName ?? null);
    this.formGroup.get('pixKeyType').setValue(this.webhookIntegrations.pix?.keyType ?? 'CNPJ');
    this.formGroup.get('pixKey').setValue(this.webhookIntegrations.pix?.key ?? null);

    this.webhookIntegrations.actions.forEach((action: any) => {
      let item = null;
      if (action.type === 'phone') {
        item = this.formBuilder.group({
          type: [WebhookIntegrationItemType.WHATSAPP_PHONE, Validators.required],
          label: ['Número do WhatsApp'],
          message: ['Informe o campo que contém o número do WhatsApp do contato.'],
          value: [action.value, Validators.required],
          required: [true],
        });
      } else if (action.type === 'name') {
        item = this.formBuilder.group({
          type: [WebhookIntegrationItemType.CONTACT_NAME, Validators.required],
          label: ['Nome do Contato'],
          message: ['Informe o campo que contém o nome do contato.'],
          value: [action.value, Validators.required],
          required: [true],
        });
      } else if (action.type === 'addTag') {
        item = this.formBuilder.group({
          type: [WebhookIntegrationItemType.ADD_TAG, Validators.required],
          label: ['Adicionar etiqueta'],
          message: ['Selecione a etiqueta que será adicionada ao contato após o mesmo ser cadastrado em sua audiência.'],
          value: [action.value, Validators.required],
          required: [false],
        });
      } else if (action.type === 'removeTag') {
        item = this.formBuilder.group({
          type: [WebhookIntegrationItemType.REMOVE_TAG, Validators.required],
          label: ['Remover etiqueta'],
          message: ['Selecione a etiqueta que será removida do contato. Caso o contato não possua a etiqueta, essa ação será ignorada e pulada.'],
          value: [action.value, Validators.required],
          required: [false],
        });
      } else if (action.type === 'addContactGroup') {
        item = this.formBuilder.group({
          type: [WebhookIntegrationItemType.ADD_CONTACT_GROUP, Validators.required],
          label: ['Adicionar contato no grupo'],
          message: ['Selecione o grupo que será adicionada ao contato após o mesmo ser cadastrado em sua audiência.'],
          value: [action.value, Validators.required],
          required: [false],
        });
      } else if (action.type === 'removeContactGroup') {
        item = this.formBuilder.group({
          type: [WebhookIntegrationItemType.REMOVE_CONTACT_GROUP, Validators.required],
          label: ['Remover contato do grupo'],
          message: ['Selecione o grupo que será removida do contato. Caso o contato não possua o grupo, essa ação será ignorada e pulada.'],
          value: [action.value, Validators.required],
          required: [false],
        });
      } else if (action.type === 'attendance') {
        item = this.formBuilder.group({
          type: [WebhookIntegrationItemType.START_ATTENDANCE, Validators.required],
          label: ['Iniciar atendimento'],
          message: ['Selecione um departamento para dar início a um atendimento, você também pode selecionar um atendente específico, mas essa parte é opcional'],
          value: [action.value.department, Validators.required],
          attendent: [action.value.user],
          required: [false],
        });
      }
      if (item) {
        this.items.push(item);
      }
    });
    if (this.isActive) {
      this.formGroup.get('name').disable();
      this.formGroup.get('url').disable();
      this.formGroup.get('channel').disable();
      this.formGroup.get('company').disable();
      this.formGroup.get('webhook').disable();
      this.formGroup.get('tags').disable();
      this.formGroup.get('uuid').disable();
      this.formGroup.get('requestType').disable();
      this.items.controls.forEach(control => {
        control.disable();
      });
    } else {
      this.formGroup.get('name').enable();
      this.formGroup.get('url').enable();
      this.formGroup.get('channel').enable();
      this.formGroup.get('company').enable();
      this.formGroup.get('webhook').enable();
      this.formGroup.get('tags').enable();
      this.formGroup.get('uuid').enable();
      this.formGroup.get('requestType').enable();
      this.items.controls.forEach(control => {
        control.enable();
      });
    }
    this.ableDisableFields();
  }

  get items(): FormArray {
    return this.formGroup.get('items') as FormArray;
  }

  getItemForm(index: number): FormGroup {
    return this.items.at(index) as FormGroup;
  }

  getWebhookRequests() {
    const excludeParams = new Set(['code', 'uuid'])

    this.webhookIntegrationsService
      .getEventsByUUID(this.webhookIntegrations.uuid)
      .subscribe((webhook: Array<Webhook>) => {
        webhook.map((webhook) => {
          const exist = this.webhooks.some((el) => el._id === webhook._id)
          if (!exist) {
            this.webhooks.push({
              _id: webhook._id,
              channel: webhook.channel,
              createdAt: webhook.createdAt,
              updatedAt: webhook.updatedAt,
              removed: webhook.removed,
              message: webhook.message,
              event: webhook.event,
              headers: webhook.headers,
              metadata: {
                ...webhook.metadata.query,
                ...Object.fromEntries(
                  Object.entries(webhook.metadata.params).filter(
                    (e) => !excludeParams.has(e[0])
                  )
                ),
                ...webhook.metadata.body,
              },
            })
          }
        })

        if (this.getParam('id')) {
          const webhookSelected = this.webhooks.filter(
            (wb) =>
              wb._id === (this.webhookIntegrations.webhook as unknown as string)
          )[0]
          this.webhookRequests = webhookSelected?.metadata
          this.formGroup.get('tags').patchValue(webhookSelected?._id)
        }
      })
  }

  webhookRequestSelected(index) {
    this.webhookRequests = this.webhooks[index].metadata;
    this.webhookSelectedId = this.webhooks[index]._id;
    this.formGroup.get('webhook').setValue(this.webhooks[index]._id);
  }

  createActionTypeList() {
    this.actionsType = [];
    if (this.selectedChannel?.type === ChannelTypeEnum.CLOUD_API) {
      this.actionsType.push(WebhookIntegrationItemType.ADD_TAG);
      this.actionsType.push(WebhookIntegrationItemType.REMOVE_TAG);
      this.actionsType.push(WebhookIntegrationItemType.ADD_CONTACT_GROUP);
      this.actionsType.push(WebhookIntegrationItemType.REMOVE_CONTACT_GROUP);
      this.actionsType.push(WebhookIntegrationItemType.START_ATTENDANCE);
    } else {
      this.actionsType.push(WebhookIntegrationItemType.ADD_TAG);
      this.actionsType.push(WebhookIntegrationItemType.REMOVE_TAG);
      this.actionsType.push(WebhookIntegrationItemType.ADD_CONTACT_GROUP);
      this.actionsType.push(WebhookIntegrationItemType.REMOVE_CONTACT_GROUP);
      this.actionsType.push(WebhookIntegrationItemType.START_ATTENDANCE);
    }
  }

  getActionTypeLabel(type: string): string {
    return WebhookIntegrationItemTypeTranslate[type];
  }

  addComponent(type: string): void {
    let item = null;
    if (type === WebhookIntegrationItemType.WHATSAPP_PHONE) {
      item = this.formBuilder.group({
        type: [WebhookIntegrationItemType.WHATSAPP_PHONE, Validators.required],
        label: ['Número do WhatsApp'],
        message: ['Informe o campo que contém o número do WhatsApp do contato.'],
        value: [null, Validators.required],
        required: [true],
      });
    } else if (type === WebhookIntegrationItemType.CONTACT_NAME) {
      item = this.formBuilder.group({
        type: [WebhookIntegrationItemType.CONTACT_NAME, Validators.required],
        label: ['Nome do Contato'],
        message: ['Informe o campo que contém o nome do contato.'],
        value: [null, Validators.required],
        required: [true],
      });
    } else if (type === WebhookIntegrationItemType.ADD_TAG) {
      item = this.formBuilder.group({
        type: [WebhookIntegrationItemType.ADD_TAG, Validators.required],
        label: ['Adicionar etiqueta'],
        message: ['Selecione a etiqueta que será adicionada ao contato após o mesmo ser cadastrado em sua audiência.'],
        value: [null, Validators.required],
        required: [false],
      });
    } else if (type === WebhookIntegrationItemType.REMOVE_TAG) {
      item = this.formBuilder.group({
        type: [WebhookIntegrationItemType.REMOVE_TAG, Validators.required],
        label: ['Remover etiqueta'],
        message: ['Selecione a etiqueta que será removida do contato. Caso o contato não possua a etiqueta, essa ação será ignorada e pulada.'],
        value: [null, Validators.required],
        required: [false],
      });
    } else if (type === WebhookIntegrationItemType.ADD_CONTACT_GROUP) {
      item = this.formBuilder.group({
        type: [WebhookIntegrationItemType.ADD_CONTACT_GROUP, Validators.required],
        label: ['Adicionar contato no grupo'],
        message: ['Selecione o grupo que será adicionada ao contato após o mesmo ser cadastrado em sua audiência.'],
        value: [null, Validators.required],
        required: [false],
      });
    } else if (type === WebhookIntegrationItemType.REMOVE_CONTACT_GROUP) {
      item = this.formBuilder.group({
        type: [WebhookIntegrationItemType.REMOVE_CONTACT_GROUP, Validators.required],
        label: ['Remover contato do grupo'],
        message: ['Selecione o grupo que será removida do contato. Caso o contato não possua o grupo, essa ação será ignorada e pulada.'],
        value: [null, Validators.required],
        required: [false],
      });
    } else if (type === WebhookIntegrationItemType.START_ATTENDANCE) {
      if (!this.items.controls.some((item) => item.get('type').value === WebhookIntegrationItemType.START_ATTENDANCE)) {
        item = this.formBuilder.group({
          type: [WebhookIntegrationItemType.START_ATTENDANCE, Validators.required],
          label: ['Iniciar atendimento'],
          message: ['Selecione um departamento para dar início a um atendimento, você também pode selecionar um atendente específico, mas essa parte é opcional'],
          value: [null, Validators.required],
          attendent: [null],
          required: [false],
        });
      }
    }
    if (item) {
      this.items.push(item);
    }
  }

  public generateWebhookIntegrationsURLbyCode(uuid: string): string {
    const code = super.getCodeCompanyCurrentUser()
    return `${environment.trendIntegrationsUrl}/webhook/${code}/${uuid}`
  }

  deleteComponent(index: number): void {
    const dialogRef = this.dialog.open(ConfirmationComponent, {
      width: '600px',
      data: this.t('integrations.santriForm.deleteActionConfirm'),
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (Boolean(result) === true) {
        this.items.removeAt(index);
        this.alertService.success(this.t('integrations.santriForm.deleteActionSuccess'));
      }
    });
  }

  ableDisableFields() {
    if (this.isActive) {
      this.formGroup.get('name').disable();
      this.formGroup.get('url').disable();
      this.formGroup.get('channel').disable();
      this.formGroup.get('company').disable();
      this.formGroup.get('webhook').disable();
      this.formGroup.get('tags')?.disable();
      this.formGroup.get('uuid').disable();
      this.formGroup.get('requestType').disable();
      this.formGroup.get('caption')?.disable();
      this.items.controls.forEach(control => {
        control.disable();
      });
    } else {
      this.formGroup.get('name').enable();
      this.formGroup.get('url').enable();
      this.formGroup.get('channel').enable();
      this.formGroup.get('company').enable();
      this.formGroup.get('webhook').enable();
      this.formGroup.get('tags')?.enable();
      this.formGroup.get('uuid').enable();
      this.formGroup.get('requestType').enable();
      this.formGroup.get('caption')?.enable();
      this.items.controls.forEach(control => {
        control.enable();
      });
    }
  }

  view(webhook: Webhook) {
    this.dialog.open(WebhookIntegrationsRequestsViewComponent, {
      width: '1000px',
      height: '800px',
      data: { webhook, url: this.webhookIntegrations.url }
    });
  }
}
